import { handleEscape } from '../../events/events';

import { useEventListener } from './useEventListener';

type UseOnEscape =
(callback: (e: Event | React.KeyboardEvent) => void) => void;

/** Takes a callback that accepts event object and runs it on `escape` keydown. */
export const useOnEscape: UseOnEscape =
  callback => {
    useEventListener(
      'keydown',
      handleEscape(callback)
    );
  };
